import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class CompanyDashboardService {
  static getDashboardData(companyId, regulationId, date) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.COMPANYSUPPLIERSRISK.replace("<companyId>", companyId)
        .replace("<regulationId>", regulationId)
        .replace("<date>", date)
    );
  }
  static getHighRiskSuppliers(encodedUrlParam, date) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.HIGHRISKSUPPLIER.replace(
        "<encodedUrlParam>",
        encodedUrlParam
      )
        .replace("<date>", date)
        .replace("<pageNumber>", 0)
        .replace("<pageSize>", 5)
        .replace("<sort>", "weightedScore,desc")
    );
  }

  static getTopCountryRisk(companyId, regulationId, date) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.TOPCOUNTRYRISK.replace("<companyId>", companyId)
        .replace("<regulationId>", regulationId)
        .replace("<date>", date)
    );
  }
  static listAlerts(
    regulationCode = "",
    pageNumber = 0,
    pageSize = 10,
    sort = "priority",
    sortOrder = "asc",
    searchVal,
  ) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.LISTALERTS.replace("<pageSize>", pageSize)
        .replace("<pageNumber>", pageNumber)
        .replace(
          regulationCode
            ? "<regulationCode>"
            : "&regulationCode=<regulationCode>",
          regulationCode
        )
        .replace("<sort>", sort)
        .replace("<sortOrder>", sortOrder)
    );
  }
  static convertAlerttoTask(param, alertId) {
    return HttpUtil.post(
      API_ROUTES.DASHBOARD.CONVERTALERTTOTASK.replace("<alertId>", alertId),
      param
    );
  }
  static getUsers(key = "", pageSize = "", pageNumber = "") {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.GETUSERS.replace(pageSize ? "<pageSize>" : "?pageSize=<pageSize>", pageSize)
        .replace(
          pageNumber ? "<pageNumber>" : "&pageNumber=<pageNumber>",
          pageNumber
        )
        .replace(key ? "<key>" : "&key=<key>", key)
    );
  }
  static listSupplierAlerts(
    encodedParam,
    regulationCode = "",
    pageNumber = 0,
    pageSize = 10,
    sort = "priority",
    sortOrder = "asc",
    searchVal
  ) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.LISTSUPPLIERALERTS.replace(
        "<encodedUrlParam>",
        encodedParam
      )
        .replace("<pageSize>", pageSize)
        .replace("<pageNumber>", pageNumber)
        .replace(
          regulationCode
            ? "<regulationCode>"
            : "&regulationCode=<regulationCode>",
          regulationCode
        )
        .replace("<sort>", sort)
        .replace("<sortOrder>", sortOrder)
    );
  }
  static listTasks(
    pageNumber = 0,
    pageSize = 10,
    regulationCode = "",
    companyId = "",
    key = "",
    sort = "",
    status = "",
    priority = "",
    assigneeId = "",
    ownerId = "",
    filter
  ) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.LISTTASKS
        .replace("<pageSize>", pageSize)
        .replace("<pageNumber>", pageNumber)
        .replace(
          regulationCode
            ? "<regulationCode>"
            : "&regulationCode=<regulationCode>",
          regulationCode
        )
        .replace(
          companyId ? "<companyId>" : "&companyId=<companyId>",
          companyId
        )
        .replace("<assignedToMe>", filter === "assignedToMe" ? true : false)
        .replace("<createdByMe>", filter === "createdByMe" ? true : false)
        .replace("<key>", key)
        .replace("<sort>", sort)
        .replace("<status>", status)
        .replace("<priority>", priority)
        .replace("<assignee_id>", assigneeId)
        .replace("<owner_id>", ownerId)

    );
  }

  static getSupplierStatusCountryReport(companyId, regulationId, date) {
    return HttpUtil.get(
      API_ROUTES.COMPANY.SUPPLIER_STATUS_COUNTRY_REPORT
        .replace("<companyId>", companyId)
        .replace("<regulationId>", regulationId)
        .replace("<period>", date)
    );
  }

  static getTop5CompaniesWithHighRisk(supplierId, regulationCode, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.COMPANIES_WITH_HIGH_RISK
        .replace("<supplierId>", supplierId)
        .replace("<regulationCode>", regulationCode)
        .replace("<period>", period)
    );
  }
  static getFormSubmissionExpiryInfo(
    pageNumber = 0,
    pageSize = 10,
    regulationId = 0) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.FORM_SUBMISSION_EXPIRY
        .replace("<pageSize>", pageSize)
        .replace("<pageNumber>", pageNumber)
        .replace(
          regulationId
            ? "<regulationId>"
            : "&regulationId=<regulationId>",
          regulationId
        )
    );
  }
  static getCompanyRiskData(companyId, configurationId, date) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.COMPANYRISK.replace("<companyId>", companyId)
        .replace("<configuration>", configurationId)
        .replace("<date>", date)
    );
  }

  static getEnergyProducedData(stdId, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.ENERGYPRODUCED.replace("<standardId>", stdId).replace("<period>", period)
    );
  }
  static getEnergyConsumptionWithin(stdId, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.ENERGYCONSUMPTIONWITHIN.replace("<standardId>", stdId).replace("<period>", period)
    );
  }
  static getEnergyConsumptionOutside(stdId, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.ENERGYCONSUMPTIONOUTSIDE.replace("<standardId>", stdId).replace("<period>", period)
    );
  }
  static getEnergyIntensityOremilled(stdId, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.AVGENERGYINTENSITYOREMILLED.replace("<standardId>", stdId).replace("<period>", period)
    );
  }
  static getEnergyIntensityWithMetal(stdId, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.ENERGYINTENSITYBYMETAL.replace("<standardId>", stdId).replace("<period>", period)
    );
  }
  static getTaskAndAlertCount(regulationId) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.GET_TASK_AND_ALERT_COUNT.replace("<regulationId>", regulationId)
    );
  }
  static getWorkForceType(stdId, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.WORKFORCETYPE.replace("<standardId>", stdId).replace("<period>", period)
    );
  }
  static getDiversity(stdId, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.DIVERSITYEMPLOYEES.replace("<standardId>", stdId).replace("<period>", period)
    );
  }
  static getNewHired(stdId, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.NEWHIREDEMPLOYEES.replace("<standardId>", stdId).replace("<period>", period)
    );
  }
  static getEconomicValueDistributed(stdId, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.ECONOMICVALUEDISTRIBUTED.replace("<standardId>", stdId).replace("<period>", period)
    );
  }
  static getEconomicValueByLocation(stdId, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.ECONOMICVALUEBYLOCATION.replace("<standardId>", stdId).replace("<period>", period)
    );
  }
  static getWasteGeneratedInOrg(stdId, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.WASTEGENERATEDINORG.replace("<standardId>", stdId).replace("<period>", period)
    );
  }
  static getWasteDisposedInOrg(stdId, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.WASTEDISPOSEDINORG.replace("<standardId>", stdId).replace("<period>", period)
    );
  }
  static getWaterWithdrawal(stdId, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.WATERWITHDRAWAL.replace("<standardId>", stdId).replace("<period>", period)
    );
  }
  static getWaterConsumption(stdId, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.WATERCONSUMPTION.replace("<standardId>", stdId).replace("<period>", period)
    );
  }

  static getScope123Emission(stdId, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.SCOPE_123_EMISSION.replace("<standardId>", stdId).replace("<period>", period)
    );
  }

  static getSocialEmployment(stdId, period) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.SOCIAL_EMPLOYMENT.replace("<standardId>", stdId).replace("<period>", period)
    );
  }
  static getMonthlyDPBasedGraph(stdId, period, type) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.MONTHLY_DP_BASED_GRAPH
        .replace("<period>", period)
        .replace("<standardId>", stdId)
        .replace("<type>", type)
    );
  }

  static getMetricDVAnalytics(filter) {
    return HttpUtil.post(
      API_ROUTES.ANALYTICS.GET_METRIC_DV, filter);
  }

  static getMetricDVGraph(filter) {
    return HttpUtil.post(
      API_ROUTES.ANALYTICS.GET_METRIC_DV_GRAPH, filter);
  }

  static getAnalyticsFilters(standardId, configType = 'CONFIGURATION', pageNumber = 0, pageSize = 10) {
    return HttpUtil.get(
      API_ROUTES.ANALYTICS.GET_ANALYTICS_FILTERS + 
      `?standardId=${standardId}&configType=${configType}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  }

  static saveAnalyticsFilter(payload) {
    return HttpUtil.post(
      API_ROUTES.ANALYTICS.SAVE_ANALYTICS_FILTER,
      payload
    );
  }

  static deleteAnalyticsFilter(filterId) {
    return HttpUtil.delete(
      `${API_ROUTES.ANALYTICS.DELETE_ANALYTICS_FILTER}/${filterId}`
    );
  }

  static getDatapointDVAnalytics(filter) {
    return HttpUtil.post(
      API_ROUTES.ANALYTICS.GET_DATAPOINT_DV, filter);
  }
}
